/* ============================================================
   จัดการ "คอลัมน์ที่แสดงในตาราง" แบบใช้ซ้ำได้ทุกหน้า
   จำค่าไว้ใน cookie ของเครื่องนั้น ๆ

   วิธีใช้ในหน้ารายการ :

     const allColumns = accessColumn({ ... });
     const { columns: column, settingsButton } =
       useColumnSettings("ชื่อ_cookie_ของหน้านี้", allColumns);

     ...แล้ววาง {settingsButton} ไว้ในหัวตาราง
     ส่วน <Table columns={column} /> ใช้ตัวแปรเดิมได้เลย

   หมายเหตุ : ชื่อ cookie ต้องไม่ซ้ำกันระหว่างหน้า
============================================================ */
import { useMemo, useState } from "react";
import ColumnSettings from "../components/table/ColumnSettings";
import { getHiddenColumns, saveHiddenColumns } from "../utils/table-cookie";

/* คอลัมน์ปุ่มตัวเลือกซ่อนไม่ได้ ไม่งั้นผู้ใช้จะกดแก้ไข/พิมพ์อะไรไม่ได้เลย */
const DEFAULT_LOCKED = ["operation", "action"];

export default function useColumnSettings(
  cookieName,
  allColumns = [],
  { lockedKeys = DEFAULT_LOCKED, buttonText = "จัดการคอลัมน์" } = {}
) {
  const [hidden, setHidden] = useState(() => getHiddenColumns(cookieName));

  const handleChange = (next) => {
    setHidden(next);
    saveHiddenColumns(cookieName, next);
  };

  /* คอลัมน์ที่เอาไปให้ <Table> จริง ๆ */
  const columns = useMemo(
    () => (allColumns || []).filter((c) => !hidden.includes(c?.key)),
    [allColumns, hidden]
  );

  const settingsButton = (
    <ColumnSettings
      columns={allColumns}
      hidden={hidden}
      onChange={handleChange}
      lockedKeys={lockedKeys}
      buttonText={buttonText}
    />
  );

  return { columns, hidden, setHidden: handleChange, settingsButton };
}
